<template>
  <v-row>
    <v-col cols="12" :class="cmp_class">
      <v-dialog
        ref="dialog"
        v-model="show_dialogue"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            clearable
            class="flex-md-grow-1"
            dense
            outlined
            filled
            autocomplete="off"
            :label="label"
            :prepend-inner-icon="icon"
            :disabled="disabled"
            v-model="date"
            :rules="validation_rules"
            :required="required"
            readonly
            v-bind="attrs"
            v-on="on"
            :error-messages="error_messages"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" scrollable  :min="min" :max="max">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="show_dialogue = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DateField",
  props: {
    error_messages: {
      type: Array,
      default: () => {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    cmp_class: {
      type: String,
      default: "mt-0 mb-1 pb-0 pt-2",
    },
    icon: {
      type: String,
      default: "mdi-calendar",
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    validation_rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
    format:{
        type: String,
        default: "YYYY-MM-DD"
    },
    min: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      show_dialogue: false,
    };
  },
  computed: {
    date: {
      get() {
        if (
          typeof this.value == "undefined" ||
          this.value == undefined ||
          this.value == null ||
          this.value.toString().trim() == ""
        ) {
          return new Date().toISOString().substr(0, 10);
        }
        return this.value;
      },
      set(new_value) {
        this.$emit("input", new_value);
      },
    },
  },
};
</script>